import EventSettingDetail from './EventSettingDetail'
export default EventSettingDetail